export { default as TabHeaderCharge } from './Charge.tab';
export { default as TabHeaderProcessor } from './Processor.tab';
export { default as TabHeaderPeriod } from './Period.tab';
export { default as TabHeaderMany } from './Many.tab';
export { default as TabHeaderSame } from './Same.tab';
export { default as TabHeaderAct } from './Act.tab';
